export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="flex flex-col lg:flex-row items-center gap-10 bg-gradient-to-br from-primary-500 to-primary-700 rounded-2xl overflow-hidden">
          <div className="flex-1 p-8 md:p-12 lg:p-14">
            <span className="inline-block bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4 whitespace-nowrap">
              随时随地
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
              手机观影 · 随时随地享受二人世界
            </h2>
            <p className="text-sm md:text-base text-white/75 leading-relaxed mb-8 max-w-lg">
              夫妻影院全面适配移动端，躺在床上、窝在沙发，随时随地打开手机就能享受免费高清在线观看。完美支持横竖屏切换，流畅不缓冲，让浪漫电影陪伴你们的每一个温馨夜晚。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <button className="inline-flex items-center gap-2 bg-white text-primary-600 font-semibold px-6 py-3 rounded-full text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-smartphone-line"></i>
                </span>
                手机端体验
              </button>
              <button className="inline-flex items-center gap-2 border border-white/30 text-white font-medium px-6 py-3 rounded-full text-sm hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-qr-code-line"></i>
                </span>
                扫码直达
              </button>
            </div>
          </div>
          <div className="flex-1 relative min-h-[320px] lg:min-h-[400px] w-full">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20held%20in%20hand%20displaying%20a%20romantic%20movie%20on%20screen%20in%20a%20cozy%20dimly%20lit%20bedroom%2C%20fairy%20lights%20in%20background%2C%20soft%20blanket%20and%20pillows%2C%20warm%20intimate%20atmosphere%2C%20night%20time%20scene%2C%20cinematic%20mood%20with%20shallow%20depth%20of%20field%2C%20modern%20lifestyle%20photography&width=600&height=800&seq=app-mobile-cinema&orientation=portrait"
              alt="夫妻影院手机端观影体验"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}